<template>
	<div>
        <vue-headful :title="dashboard.dashboard_name+' [Dashboard] :: MeritEHS'" />

	    <h4 class="mt-2 mb-4">
	    	<ol class="breadcrumb font-weight-bold m-0">
	    		<li class="breadcrumb-item font-weight-light d-block d-md-inline-block">
                    <router-link :to="`/`">
                        <i class="fa fa-dashboard"></i> Dashboard
                    </router-link>
                </li>
                <li class="breadcrumb-item font-weight-light d-block d-md-inline-block">
                    <router-link :to="`/dashboards/settings`">
                        Settings
                    </router-link>
                </li>
                <li class="breadcrumb-item font-weight-light d-block d-md-inline-block">
                    <router-link :to="`/dashboards/settings/view/${dashboard.id}`">
                        {{ dashboard.dashboard_name }}
                    </router-link>
                </li>
                <li class="breadcrumb-item active d-block d-md-inline-block mt-md-0 mt-2">
                    Delete
                </li>
	    	</ol>
	    </h4>

        <div class="row">
            <div class="col-lg-6 col-md-8">
                <div class="card mb-4">
                    <div class="card-header">
                        Delete Dashboard: {{ dashboard.dashboard_name }}

                    </div>
                    <div class="card-body">
                        <div class="alert alert-danger">
                            Are you sure you want to delete dashboard: <strong>{{ dashboard.dashboard_name }}</strong>? This cannot be undone.
                        </div>
                    </div>
                </div>

                <button type="button" class="btn btn-sm btn-danger" v-on:click="deleteDashboard()">
                    Delete Dashboard
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                dashboard_id: this.$route.params.id,
                dashboard: {},
            }
        },

        watch: {

        },

        computed: {

        },

        methods: {

            getDashboard() {
                this.$http.get('/dashboards/settings/view/'+this.dashboard_id)
                .then(response => {
                    //SEt it
                    this.dashboard = response.data.dashboard;
                })
                .catch(err => {

                });
            },

            deleteDashboard(){
               this.$http.post('/dashboards/settings/delete/'+this.dashboard_id)
               .then(response => {
                    //Alert the user?
                    this.$toastr.success('Dashboard Deleted');

                    //SEt it
                    this.$router.push('/dashboards/settings');
               })
               .catch(err => {

               });
            }
        },

        mounted() {
            this.getDashboard();
        }
    }
</script>